export default __webpack_public_path__ + "static/media/fret_ferret_logo.e34dd668.png";